import { DefaultRefreshHandler } from '/src/node_modules/@sidebase/nuxt-auth/dist/runtime/utils/refreshHandler'
export const _refreshHandler = new DefaultRefreshHandler({"enablePeriodically":300000,"enableOnWindowFocus":true})